import getFieldRenderObject from '../../../utils/newforms/render/getFieldRenderObject'
import { buildUtmSelectOptions } from '../utmBuilderFormOptions'

class UtmLinkForm {
  constructor(utmConfig) {
    const selectOptions = buildUtmSelectOptions(utmConfig)

    this.isActive = {
      field: {
        fieldId: 'isActive',
        fieldType: 'checkbox',
        label: 'Активне коротке посилання',
        value: true,
      },
      render: getFieldRenderObject(),
    }
    this.owner = {
      field: {
        fieldId: 'owner',
        fieldType: 'select',
        getOptions: selectOptions.owners,
        label: 'Відповідальний',
        required: true,
      },
      render: getFieldRenderObject(),
    }
    this.title = {
      field: {
        fieldId: 'title',
        fieldType: 'input',
        inputType: 'text',
        label: 'Назва кампанії',
        required: true,
      },
      render: getFieldRenderObject(),
    }
    this.destinationUrl = {
      field: {
        fieldId: 'destinationUrl',
        fieldType: 'input',
        inputType: 'text',
        label: 'URL призначення',
        required: true,
      },
      render: getFieldRenderObject(),
    }
    this.channel = {
      field: {
        fieldId: 'channel',
        fieldType: 'select',
        getOptions: selectOptions.channels,
        label: 'Канал / utm_source',
        required: true,
      },
      render: getFieldRenderObject(),
    }
    this.format = {
      field: {
        fieldId: 'format',
        fieldType: 'select',
        getOptions: selectOptions.formats,
        label: 'Формат / content type',
        required: true,
      },
      render: getFieldRenderObject(),
    }
    this.direction = {
      field: {
        fieldId: 'direction',
        fieldType: 'select',
        getOptions: selectOptions.directions,
        label: 'Напрямок',
        required: true,
      },
      render: getFieldRenderObject(),
    }
    this.campaign_date = {
      field: {
        fieldId: 'campaign_date',
        fieldType: 'input',
        inputType: 'text',
        label: 'Дата кампанії / публікації',
        placeholder: '',
        required: false,
      },
      render: getFieldRenderObject(),
    }
  }
}

export default UtmLinkForm
